(function (angular) {
    'use strict';
    angular
        .module('SMART2').factory('PUBLICURLs', ['APPCONSTANTS', function (APPCONSTANTS) {
            var bpc = APPCONSTANTS.userPreferences.UserBasicDetails.BuyerPartnerCode, dd = APPCONSTANTS.userPreferences.dd, encryptedBpc = APPCONSTANTS.userPreferences.EncryptedBPC, timezone = APPCONSTANTS.userPreferences.UserBasicDetails.timeZoneName,
                pulbicURLS = {
                    helpCenter: "/GetSupportInfo?dd=" + dd,
                    registrationUrl: APPCONSTANTS.userPreferences.URLs.RegistrationURL + "&oloc=102 ",
                    publicRfx: "/GetPublicRfxManageData?dd=" + dd , // "https://smartdev.gep.com/api/ManageData?oloc=281",
                    fileDownloadUrl: "/DownloadAttachment?dd=" + dd,
                    regionUrl: APPCONSTANTS.userPreferences.URLs.AppURL + "/Controls/TreeView/GetRegionDetails?oloc=102&bpc=" + encryptedBpc,
                    loginUrl: APPCONSTANTS.userPreferences.URLs.AppURL + "?oloc=101",
                    getRegistrationUrl: APPCONSTANTS.userPreferences.URLs.AppURL + "/Nexus/PartnerProfile/GetDirectLinkUrl?oloc=102&bpc=" + bpc + "&timezone=" + timezone
                };
            return pulbicURLS;
        }]);
})(angular);
